import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Industryusa = () => {
  return (
    <div className="Industry_usa tekrevol_dark_bg  p-100 ">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={5} lg={5} xl={5} xxl={5}>
            <h2>
              TekRevol's <span>Enterprise App Development Services</span> For
              Different Industries
            </h2>
            <p>
              With experience spanning startups and large enterprises, TekRevol
              transforms businesses using vast knowledge to deliver cutting-edge
              digital solutions across various industries.
            </p>
            <p>
              Our wide-ranging expertise with diverse clients enables us to
              customize innovative solutions specifically designed for the
              distinct needs and hurdles of every industry we engage with.
            </p>
            <p>Here are the industries that we have expertise in:</p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Let’s Build Your Enterprise App
            </Link>
          </Col>
          <Col
            xs={12}
            md={4}
            lg={4}
            xl={4}
            xxl={4}
            className="offset-lg-3 offset-md-3 my-auto"
          >
            <div className="industry_scroll">
              <h3>Fintech</h3>
              <h3>Healthcare</h3>
              <h3>E-commerce</h3>
              <h3>Real Estate</h3>
              <h3>Automotive</h3>
              <h3>On-Demand</h3>
              <h3>Education</h3>
              <h3>Music</h3>
              <h3>IT Staff Augmentation</h3>
              <h3>Logistics</h3>
              <h3>Retail</h3>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Industryusa;
